import React from 'react';
import { Button, Image } from 'antd';
import { useTranslation } from 'react-i18next';

import gif1 from '@/assets/images/mai-ha-hi.gif';
import gif2 from '@/assets/images/tunak-tunak-tun.gif';
import gif3 from '@/assets/images/wassup.gif';
import gif4 from '@/assets/images/we-will-rock-you.gif';
import jpg1 from '@/assets/images/mai-ha-hi.jpg';
import jpg2 from '@/assets/images/tunak-tunak-tun.jpg';
import jpg3 from '@/assets/images/wassup.jpg';
import jpg4 from '@/assets/images/we-will-rock-you.jpg';

import '@/assets/addLipShape.less';

const AddLipShapeWorkGIFRender = ({ currFile, handleChooseTemplate }) => {
  const { t } = useTranslation(['addLipShape']);
  return (
    <div className='step-con'>
      <div className='step-header'>
        <span
          className={`step-num ${
            currFile && currFile.uploadStatus ? 'active' : ''
          }`}
        >
          <span>2</span>
        </span>
        {t('Choose a GIF')}
      </div>
      <div className='work-cont'>
        <div
          className={`work-gif-demo-list ${
            currFile && currFile.uploadStatus ? '' : 'disabledClick'
          }`}
        >
          <div className='work-gif-demo-item'>
            <div className='item-pic-cont'>
              <Image className='demo-gif' src={gif1} preview={false} />
              <Image className='demo-jpg' src={jpg1} preview={false} />
              <div className='tips'>Mai-Ha-Hi!</div>
            </div>
            <Button
              type='primary'
              size='large'
              onClick={() =>
                handleChooseTemplate(
                  'https://piccutout-sgp-prod.oss-ap-southeast-1.aliyuncs.com/example/face-animator/mai-ha-hi.mp4'
                )
              }
            >
              {t('Use this template')}
            </Button>
          </div>

          <div className='work-gif-demo-item'>
            <div className='item-pic-cont'>
              <Image className='demo-gif' src={gif2} preview={false} />
              <Image className='demo-jpg' src={jpg2} preview={false} />
              <div className='tips'>Tunak Tun!</div>
            </div>
            <Button
              type='primary'
              size='large'
              onClick={() =>
                handleChooseTemplate(
                  'https://piccutout-sgp-prod.oss-ap-southeast-1.aliyuncs.com/example/face-animator/tunak-tun.mp4'
                )
              }
            >
              {t('Use this template')}
            </Button>
          </div>

          <div className='work-gif-demo-item'>
            <div className='item-pic-cont'>
              <Image className='demo-gif' src={gif3} preview={false} />
              <Image className='demo-jpg' src={jpg3} preview={false} />
              <div className='tips'>Wassup!</div>
            </div>
            <Button
              type='primary'
              size='large'
              onClick={() =>
                handleChooseTemplate(
                  'https://piccutout-sgp-prod.oss-ap-southeast-1.aliyuncs.com/example/face-animator/wassup.mp4'
                )
              }
            >
              {t('Use this template')}
            </Button>
          </div>

          <div className='work-gif-demo-item'>
            <div className='item-pic-cont'>
              <Image className='demo-gif' src={gif4} preview={false} />
              <Image className='demo-jpg' src={jpg4} preview={false} />
              <div className='tips'>We Will Rock You!</div>
            </div>
            <Button
              type='primary'
              size='large'
              onClick={() =>
                handleChooseTemplate(
                  'https://piccutout-sgp-prod.oss-ap-southeast-1.aliyuncs.com/example/face-animator/we-will-rock-you.mp4'
                )
              }
            >
              {t('Use this template')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddLipShapeWorkGIFRender;
